import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as Actions from './actions';
import { AppState } from '../../store';
import { bitlockVoApiPath, bitlockVoApiKey } from '../../../config/baseConfig';
import { Property } from './types';
import { getCookie } from '../../utils/cookie';

export const setIdsFromCookie = (): ThunkAction<
  {},
  {},
  {},
  AnyAction
> => async dispatch => {
  const organizationId = getCookie('organization_id');
  const contractInfoId = getCookie('contract_info_id');
  const usageInfoId = getCookie('usage_info_id');
  const peopleId = getCookie('people_id');

  if (organizationId !== undefined) {
    dispatch(Actions.setOrganizationId(organizationId));
  }
  if (contractInfoId !== undefined || usageInfoId !== undefined) {
    dispatch(Actions.setContractInfoId(contractInfoId || ''));
    dispatch(Actions.setUsageInfoId(usageInfoId || ''));
  }
  if (peopleId !== undefined) {
    dispatch(Actions.setPeopleId(peopleId));
  }
};

const ENABLED_GET_PROPERTY = false;

export const getProperty = (): ThunkAction<
  Promise<void>,
  AppState,
  {},
  AnyAction
> => async (dispatch, getState) => {
  if (!ENABLED_GET_PROPERTY) {
    // TODO: データストアが未確定のためスキップしている。確定したらこの処理を削除する
    console.log('skip getProperty. interface is not confirmed yet.');
    return;
  }

  try {
    dispatch(Actions.startToFetchProperty());
    const { usageInfoId, usageId } = getState().property.property;

    if (!usageInfoId || !usageId) {
      dispatch(Actions.failedSetProperty());
      return;
    }

    const endpoint = `${bitlockVoApiPath}/spaces/${usageInfoId}/contracts/${usageId}`;
    const headers = {
      'x-vo-api-key': bitlockVoApiKey,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };

    let propertyData = {} as Property;
    await fetch(endpoint, {
      method: 'GET',
      headers,
      mode: 'cors'
    })
      .then(res => {
        if (res.status !== 200) {
          dispatch(Actions.failedSetProperty());
          return;
        }
        res.json().then(json => {
          propertyData = {
            usageInfoId: usageInfoId,
            usageId: usageId,
            allSpaceId: json.data.allSpaceId,
            contractId: json.data.contractId,
            occupyScheduledDate: new Date(json.data.occupyScheduledDate),
            hasElectricContract: json.data.hasElectricContract,
            postCode: json.data.postCode,
            address: json.data.address,
            prefecture: json.data.prefecture,
            city: json.data.city,
            afterCity: json.data.afterCity,
            buildingName: json.data.buildingName,
            name: json.data.name,
            sumamoruCode: json.data.sumamoruCode,
            managementCompanyAddress: json.data.managementCompanyAddress,
            managementCompanyName: json.data.managementCompanyName,
            managementCompanyPhoneNumber:
              json.data.managementCompanyPhoneNumber,
            sumamoruInstallAppTypes: json.data.sumamoruInstallAppTypes,
            sumamoruProjectType: json.data.sumamoruProjectType,
            sumamoruAdditionalServices: json.data.sumamoruAdditionalServices,
            applicantType: json.data.applicantType,
            isContractorSameAsOccupant: json.data.isContractorSameAsOccupant
          };
          dispatch(Actions.setProperty(propertyData));
        });
      })
      .catch(error => {
        console.error(error);
        dispatch(Actions.failedSetProperty());
      });
  } catch (error) {
    console.error(error);
    dispatch(Actions.failedSetProperty());
  }
};
